<template>
    <div>
        <span v-if="findEntry('FLIGHT')">
            <v-icon :small="small" color="grey-lighten-1">mdi-airplane</v-icon>
        </span>
        <span v-if="findEntry('TRANSFER')">
            <v-icon :small="small" color="grey-lighten-1">mdi-bus</v-icon>
        </span>
        <span v-if="findEntry('CAR')">
            <v-icon :small="small" color="grey-lighten-1">mdi-car</v-icon>
        </span>
        <span v-if="findEntry('ACCOMMODATION')">
            <v-icon :small="small" color="grey-lighten-1">mdi-office-building</v-icon>
        </span>
        <span v-if="findEntry('EXCURSION') || findEntry('EVENT')">
            <v-icon :small="small" color="grey-lighten-1">mdi-lightning-bolt-outline</v-icon>
        </span>
        <span v-if="findEntry('INSURANCE')">
            <v-icon :small="small" color="grey-lighten-1">mdi-umbrella</v-icon>
        </span>
        <span v-if="findEntry('CRUISE')">
            <v-icon :small="small" color="grey-lighten-1">mdi-ferry</v-icon>
        </span>
        <span v-if="findEntry('TRAIN')">
            <v-icon :small="small" color="grey-lighten-1">mdi-train</v-icon>
        </span>
    </div>
</template>

<script lang="ts">
    import {Vue, Component, Prop} from 'vue-facing-decorator'

    @Component
    export class TourIncludedEntries extends Vue {
        @Prop({default: () => []}) entries
        @Prop({required: false, default: Boolean}) small

        findEntry(type) {
            return !!this.entries.find(entry => entry.type.toLowerCase() === type.toLowerCase())
        }
    }

    export default TourIncludedEntries
</script>
